<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click.prevent="getMovimenti()"> Contabilità </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">Prima Nota</span>
				</h4>
			</div>
			<div class="d-lg-block my-lg-auto ms-lg-auto text-center">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2" style="text-align: left;" v-if="$root.hasFunzionalita('PRIMA_NOTA_CREATE')" v-on:click.prevent="nuovoMovimento()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">Nuovo Movimento</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>
					<div class="vr flex-shrink-0 my-2 mx-3"></div>
					<a v-if="$root.hasFunzionalita('CONF_CONTABILITA_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click.prevent="$root.confTravelTipologiche(10)" title="Opzioni Contabilità">
						<i class="ph-lightning"></i>
					</a>
				</div>
			</div>
		</div>

		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill">
					<li class="nav-item me-1">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded active" @click.prevent>
							<div class="d-flex align-items-center mx-lg-1"><i class="ph-notebook"></i><span class="ms-1">Movimenti</span></div>
						</a>
					</li>
				</ul>
				<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
					<li class="nav-item dropdown ms-lg-1">
						<div class="btn-group">
							<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
								<i class="ph-gear me-1"></i><span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
							</a>
							<div class="dropdown-menu dropdown-menu-end">
								<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('PRIMA_NOTA_EXPORT')">
									<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
									<div class="dropdown-menu">
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')"><i class="far fa-file-export fa-fw me-2"></i>Pagina corrente</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')"><i class="far fa-file-export fa-fw me-2"></i>Movimenti selezionati</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')"><i class="far fa-file-export fa-fw me-2"></i>Tutti i movimenti</a>
									</div>
								</div>
								<div class="dropdown-divider"></div>
								<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('PRIMA_NOTA_DELETE')" @click.prevent="eliminaSelezionati()">
									<i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate>
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod && arrayMovimenti.some(m => m.SELEZIONATO == 1 && m.FLG_ELIMINATO == 1)" @click.prevent="ripristinaSelezionati()">
									<i class="fad fa-redo fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Ripristina selezionati
								</a>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- /page header -->

	<div class="content content-1 table-cms-wrapper">

		<!-- KPI del periodo -->
		<div class="row g-2 mb-2">
			<div class="col-6 col-xl-3" v-for="k in kpi" :key="k.label">
				<KpiCard :label="k.label" :icona="k.icona" :tema="k.tema" :indicatore="{ valore: k.valore, unita: k.unita }" :nota="k.nota" />
			</div>
		</div>

		<div class="card shadow mb-xs-3 mb-lg-0">
			<div class="card-body pb-0">
				<div class="alert alert-2 alert-secondary border-0">
					<div class="row g-2 align-items-center">
						<div class="col-6 col-md-2 col-xl-1">
							<select class="form-select form-select-sm" :value="presetAttivo" @change="impostaPeriodo($event.target.value)">
								<option value="" disabled>Personalizzato</option>
								<option v-for="p in preset" :key="p.id" :value="p.id">{{ p.label }}</option>
							</select>
						</div>
						<div class="col-6 col-md-2 col-xl-auto">
							<select class="form-select form-select-sm" v-model="search.SEGNO.VALUE">
								<option value="">Entrate e uscite</option>
								<option value="+">Entrate</option>
								<option value="-">Uscite</option>
							</select>
						</div>
						<div class="col-12 col-md-3 col-xl-2">
							<Datepicker v-model="periodo" range multi-calendars :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" placeholder="Periodo" @update:model-value="presetAttivo = ''; getMovimenti()" />
						</div>
						<div class="col-6 col-md-2 col-xl-auto">
							<select class="form-select form-select-sm" v-model="fkIdConto" @change="getMovimenti()">
								<option value="0">Tutti i conti</option>
								<option v-for="conto in $root.arrayConti" :key="conto.ID_OPZIONE_TIPOLOGICA" :value="conto.ID_OPZIONE_TIPOLOGICA">{{ conto.CUSTOM_1 }}</option>
							</select>
						</div>
						<div class="col-6 col-md col-xl-3">
							<SelectIntestatario v-model:pg="filtroPg" v-model:pf="filtroPf" :placeholder="'Tutti'" @change="getMovimenti()"></SelectIntestatario>
						</div>
						<div class="col-12 col-md-3 col-xl">
							<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cerca descrizione" v-model="search.DESCRIZIONE.VALUE" />
						</div>
						<div class="col-1 col-xl-auto ps-0" v-if="$root.isGod">
							<a href="#collapse-prima-nota" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" @click.prevent="filters.resizeGrid('collapse-prima-nota','tableFixHead','box-card')" role="button" aria-expanded="false">S</a>
						</div>
					</div>
					<div class="collapse" id="collapse-prima-nota" v-if="$root.isGod">
						<div class="row">
							<div class="col-12 col-md-2 mt-1">
								<select class="form-select form-select-sm" v-model="eliminati" @change="getMovimenti()">
									<option value="0">Non eliminati</option>
									<option value="2">Tutti</option>
									<option value="1">Eliminati</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card-body box-card mt-0 mb-0" id="box-card">
				<div class="div_table_resp tableFixHead" id="tableFixHead">
					<table class="table table-bordered table-hover table-striped text-nowrap align-middle">
						<thead class="sticky-top">
							<tr class="bg-secondary text-white">
								<th class="table-head-sm text-center" style="width: 2%;"><input id="chkAllMovimenti" type="checkbox" v-on:click="filters.selectAll('chkAllMovimenti', paginatedList.arr)"></th>
								<th class="table-head-sm text-center" style="width: 4%;">#</th>
								<th class="table-head-sm text-center" style="width: 10%;">Data e ora</th>
								<th class="table-head-sm" style="width: 16%;">Intestatario</th>
								<th class="table-head-sm">Descrizione</th>
								<th class="table-head-sm" style="width: 10%;">Conto</th>
								<th class="table-head-sm text-end" style="width: 12%;">Movimento</th>
								<th class="table-head-sm text-end" style="width: 9%;" title="Saldo progressivo nel periodo">Progressivo</th>
								<th class="table-head-sm" style="width: 7%;">Utente</th>
								<th class="table-head-sm text-center" style="width: 5%;"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="m in paginatedList.arr" :key="m.ID_MOVIMENTO" :class="{ 'table-danger text-muted': m.FLG_ELIMINATO == 1 }">
								<td class="td-class text-center"><input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="m.SELEZIONATO"></td>
								<td class="td-class text-center fs-sm">{{ m.ID_MOVIMENTO }}</td>
								<td class="td-class text-center fs-sm">{{ m.DATA_MOVIMENTO_IT }}</td>
								<td class="td-class fs-sm" style="max-width: 0;">
									<div class="d-flex align-items-center" v-if="m.INTESTATARIO"><TestoEspandibile :testo="m.INTESTATARIO" icona="ph-user" /><span class="badge bg-light text-muted ms-1 flex-shrink-0">{{ m.TIPO_INTESTATARIO }}</span></div>
								</td>
								<td class="td-class fs-sm" style="max-width: 0;">
									<div class="d-flex align-items-center">
										<TestoEspandibile :testo="m.DESCRIZIONE" />
										<span v-if="m.N_SCADENZE > 0" class="badge bg-info bg-opacity-20 text-info ms-1 flex-shrink-0"><i class="ph-calendar-check me-1"></i>{{ m.N_SCADENZE == 1 ? '1 scadenza' : m.N_SCADENZE + ' scadenze' }}</span>
										<span v-if="m.FLG_ELIMINATO == 1" class="badge bg-danger ms-1 flex-shrink-0">{{ m.SCADENZE_ANNULLATE ? 'Pagamento annullato' : 'Eliminato' }}</span>
									</div>
								</td>
								<td class="td-class fs-sm">{{ m.CONTO }}</td>
								<td class="td-class fs-sm text-end" :class="m.SEGNO == '+' ? 'text-success' : 'text-danger'"><i class="me-1" :class="m.SEGNO == '+' ? 'ph-arrow-down-left' : 'ph-arrow-up-right'"></i>{{ m.SEGNO }} &euro; {{ filters.formattaImporto(m.IMPORTO) }}</td>
								<td class="td-class fs-sm text-end" :class="{ 'text-danger': progressivo[m.ID_MOVIMENTO] < 0 }">{{ m.FLG_ELIMINATO == 1 ? '' : '€ ' + filters.formattaImporto(progressivo[m.ID_MOVIMENTO]) }}</td>
								<td class="td-class fs-sm">{{ m.USERNAME }}</td>
								<td class="td-class text-center">
									<div class="dropdown">
										<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false"><i class="ph-list"></i></a>
										<div class="dropdown-menu dropdown-menu-end">
											<template v-if="m.FLG_ELIMINATO != 1">
												<a href="#" class="dropdown-item" @click.prevent="modificaMovimento(m)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica</a>
												<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('PRIMA_NOTA_DELETE')" @click.prevent="elimina([m])">
													<i class="fad fa-lg fa-fw me-2" :class="m.N_SCADENZE > 0 ? 'fa-undo text-warning' : 'fa-trash text-danger'"></i><span class="text-muted me-1">|</span>{{ m.N_SCADENZE > 0 ? 'Annulla pagamento' : 'Elimina' }}
												</a>
											</template>
											<a href="#" class="dropdown-item text-success" v-if="$root.isGod && m.FLG_ELIMINATO == 1" @click.prevent="ripristina([m])"><i class="fad fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate></a>
										</div>
									</div>
								</td>
							</tr>
							<tr v-if="paginatedList.count == 0">
								<td colspan="11" class="text-center text-muted py-4">
									<i class="ph-notebook d-block mb-2" style="font-size: 2.5rem;"></i>
									Nessun movimento nel periodo
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="row page-bottom">
					<div class="col-12 col-md-5 d-none d-sm-block">
						<div style="position: relative; top: 10px;">
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">MOVIMENTI: {{ paginatedList.count }}</span>
						</div>
					</div>
					<div class="col-9 col-md-6">
						<div class="float-end pag-mobile">
							<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
						</div>
					</div>
					<div class="col-3 col-md-1">
						<select class="form-select form-select-sm wmin-100 mt-2 float-end" v-model="search.PAGINATION.PAGE_SIZE">
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
							<option value="250">250</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE MOVIMENTO -->
	<div class="modal fade" id="popUpMovimento" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">{{ movimento.ID_MOVIMENTO > 0 ? 'Movimento n. ' + movimento.ID_MOVIMENTO : 'Nuovo movimento' }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div v-if="movimento.N_SCADENZE > 0" class="alert alert-info p-2 fs-sm"><i class="ph-info me-1"></i>Pagamento dallo scadenzario: importo e azienda vengono dalle scadenze pagate.</div>

					<div class="btn-group w-100 mb-3">
						<button type="button" class="btn" :class="movimento.SEGNO == '+' ? 'btn-success' : 'btn-outline-success'" :disabled="movimento.N_SCADENZE > 0" @click="movimento.SEGNO = '+'"><i class="ph-arrow-down-left me-1"></i>Entrata</button>
						<button type="button" class="btn" :class="movimento.SEGNO == '-' ? 'btn-danger' : 'btn-outline-danger'" :disabled="movimento.N_SCADENZE > 0" @click="movimento.SEGNO = '-'"><i class="ph-arrow-up-right me-1"></i>Uscita</button>
					</div>

					<div class="input-group input-group-lg mb-3">
						<span class="input-group-text">&euro;</span>
						<input type="text" inputmode="decimal" class="form-control text-end fw-semibold" placeholder="0,00" v-model="movimento.IMPORTO" @blur="normalizza(movimento, 'IMPORTO')" :disabled="movimento.N_SCADENZE > 0">
					</div>

					<div class="row">
						<div class="col-6 mb-2">
							<label class="form-label">Data *</label>
							<Datepicker v-model="movimento.DATA_MOVIMENTO" :formats="{ input: 'dd/MM/yyyy HH:mm' }" auto-apply :clearable="false" placeholder="Data e ora" />
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Pagamento *</label>
							<SelectConto v-model="movimento.FK_ID_CONTO"></SelectConto>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Intestatario</label>
							<SelectIntestatario v-model:pg="movimento.FK_ID_PERSONA_GIURIDICA" v-model:pf="movimento.FK_ID_PERSONA_FISICA" :disabled="movimento.N_SCADENZE > 0"></SelectIntestatario>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Descrizione</label>
							<input type="text" class="form-control form-control-sm" v-model="movimento.DESCRIZIONE" autocomplete="off" placeholder="Es. bonifico saldo fattura 12/2026">
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="ph-x me-1"></i>Annulla</button>
					<template v-if="$root.hasFunzionalita(movimento.ID_MOVIMENTO > 0 ? 'PRIMA_NOTA_UPDATE' : 'PRIMA_NOTA_CREATE')">
						<button type="button" class="btn btn-sm btn-secondary" @click="salvaMovimento(false)"><i class="ph-check me-1"></i>Salva e chiudi</button>
						<button type="button" class="btn btn-sm btn-primary" v-if="movimento.ID_MOVIMENTO == 0" @click="salvaMovimento(true)"><i class="ph-check me-1"></i>Salva e continua</button>
					</template>
				</div>
			</div>
		</div>
	</div>

	<PopUpEsportazione id="popUpEsportazioneMovimenti" @esporta="esportaDati" />

</template>

<script>

import Pagine from '@/components/utils/Pagine.vue'
import SelectIntestatario from '@/components/common/SelectIntestatario.vue'
import SelectConto from '@/components/common/SelectConto.vue'
import KpiCard from '@/components/dashboard/KpiCard.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'
import TestoEspandibile from '@/components/common/TestoEspandibile.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

export default {
	name: "PrimaNota",

	components: { Pagine, SelectIntestatario, SelectConto, KpiCard, PopUpEsportazione, TestoEspandibile, Datepicker },

	data: function () {
		return {
			filters: global.filters,
			preset: [{ id: 'mese', label: 'Mese' }, { id: 'trimestre', label: 'Trimestre' }, { id: 'anno', label: 'Anno' }],
			presetAttivo: 'mese',
			periodo: [],
			filtroPg: 0,
			filtroPf: 0,
			fkIdConto: 0,
			eliminati: 0,
			esportazioneTipo: '',
			arrayMovimenti: [],
			movimento: {},
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				SEGNO: { TYPE: 'COMBO', VALUE: '' },
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
			},
		}
	},

	computed: {
		paginatedList() {
			return utils.inGrid(this.arrayMovimenti, this.search);
		},
		// Card e progressivo contano solo i movimenti validi, anche quando il god guarda gli eliminati
		attivi() {
			return this.arrayMovimenti.filter(m => m.FLG_ELIMINATO != 1);
		},
		kpi() {
			const di = (segno) => this.attivi.filter(m => m.SEGNO == segno);
			const entrate = utils.array.sumByField(di('+'), 'IMPORTO'), uscite = utils.array.sumByField(di('-'), 'IMPORTO');
			const periodo = this.periodo.length == 2 ? 'dal ' + this.filters.formatDate(this.filters.formatDateOnly(this.periodo[0])) + ' al ' + this.filters.formatDate(this.filters.formatDateOnly(this.periodo[1])) : '';
			return [
				{ label: 'Entrate', valore: entrate, unita: 'EUR', tema: 'green', icona: 'ph-arrow-circle-down-left', nota: di('+').length + ' movimenti in entrata' },
				{ label: 'Uscite', valore: uscite, unita: 'EUR', tema: 'red', icona: 'ph-arrow-circle-up-right', nota: di('-').length + ' movimenti in uscita' },
				{ label: 'Saldo periodo', valore: entrate - uscite, unita: 'EUR', tema: 'blue', icona: 'ph-scales', nota: 'Entrate meno uscite' },
				{ label: 'Movimenti', valore: this.attivi.length, unita: 'NUMERO', tema: 'purple', icona: 'ph-list-numbers', nota: periodo },
			];
		},
		// Saldo cumulato dal primo movimento del periodo (ordine cronologico), indicizzato per ID
		progressivo() {
			const ordinati = [...this.attivi].sort((a, b) => a.DATA_MOVIMENTO.localeCompare(b.DATA_MOVIMENTO) || a.ID_MOVIMENTO - b.ID_MOVIMENTO);
			let saldo = 0;
			const mappa = {};
			ordinati.forEach(m => {
				saldo += (m.SEGNO == '+' ? 1 : -1) * parseFloat(m.IMPORTO);
				mappa[m.ID_MOVIMENTO] = saldo;
			});
			return mappa;
		},
	},

	methods: {
		impostaPeriodo(id) {
			const oggi = new Date(), a = oggi.getFullYear(), m = oggi.getMonth();
			const da = { mese: new Date(a, m, 1), trimestre: new Date(a, m - m % 3, 1), anno: new Date(a, 0, 1) }[id];
			const fine = { mese: new Date(a, m + 1, 0), trimestre: new Date(a, m - m % 3 + 3, 0), anno: new Date(a, 11, 31) }[id];
			this.presetAttivo = id;
			this.periodo = [da, fine];
			this.getMovimenti();
		},

		getMovimenti() {
			const params = {
				DATA_START: this.filters.formatDateOnly(this.periodo[0]),
				DATA_END: this.filters.formatDateOnly(this.periodo[1]),
				FK_ID_CONTO: this.fkIdConto,
				FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0,
				FK_ID_PERSONA_FISICA: this.filtroPf || 0,
				ELIMINATI: this.eliminati,
			};
			utils.ajax('shared/prima_nota/lista', params, (response) => {
				this.arrayMovimenti = response.data;
			}, true, 0, 'GET');
		},

		nuovoMovimento() {
			this.movimento = this.movimentoVuoto();
			this.filters.openPopUp('popUpMovimento');
		},

		movimentoVuoto() {
			return { ID_MOVIMENTO: 0, SEGNO: '-', DATA_MOVIMENTO: new Date(), IMPORTO: '', FK_ID_CONTO: '', FK_ID_PERSONA_GIURIDICA: 0, FK_ID_PERSONA_FISICA: 0, DESCRIZIONE: '', N_SCADENZE: 0 };
		},

		modificaMovimento(m) {
			this.movimento = utils.clone(m);
			this.movimento.DATA_MOVIMENTO = new Date(m.DATA_MOVIMENTO.replace(' ', 'T'));
			this.normalizza(this.movimento, 'IMPORTO');
			this.filters.openPopUp('popUpMovimento');
		},

		salvaMovimento(continua = false) {
			const params = utils.clone(this.movimento);
			params.DATA_MOVIMENTO = global.moment(this.movimento.DATA_MOVIMENTO).format('YYYY-MM-DD HH:mm:ss');
			params.IMPORTO = this.filters.parseImporto(this.movimento.IMPORTO);
			const nuovo = !(params.ID_MOVIMENTO > 0);
			utils.ajax(nuovo ? 'shared/prima_nota/insert' : 'shared/prima_nota/update', params, (response) => {
				utils.alert.success(response.messaggio);
				if (continua) {
					this.movimento = this.movimentoVuoto();
				} else {
					this.filters.closePopUp('popUpMovimento');
				}
				this.getMovimenti();
			}, true, 0, nuovo ? 'POST' : 'PUT');
		},

		eliminaSelezionati() {
			this.elimina(this.arrayMovimenti.filter(m => m.SELEZIONATO == 1 && m.FLG_ELIMINATO != 1));
		},

		// Eliminare un pagamento rimette da pagare le sue scadenze: lo si dice nella conferma
		elimina(righe) {
			if (righe.length == 0) { utils.alert.warning('Nessun movimento selezionato.'); return; }
			const pagamenti = righe.filter(m => m.N_SCADENZE > 0).length;
			let testo = righe.length == 1 ? 'Eliminare il movimento n. ' + righe[0].ID_MOVIMENTO + '?' : 'Eliminare ' + righe.length + ' movimenti?';
			if (pagamenti > 0) testo += ' Le scadenze pagate da ' + (pagamenti == 1 ? 'questo pagamento' : pagamenti + ' pagamenti') + ' torneranno da pagare.';
			utils.alert.confirm(testo, () => {
				utils.ajax('shared/prima_nota/delete', { IDS: righe.map(m => m.ID_MOVIMENTO) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getMovimenti();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		ripristinaSelezionati() {
			this.ripristina(this.arrayMovimenti.filter(m => m.SELEZIONATO == 1 && m.FLG_ELIMINATO == 1));
		},

		ripristina(righe) {
			utils.alert.confirm(righe.length == 1 ? 'Ripristinare il movimento n. ' + righe[0].ID_MOVIMENTO + '?' : 'Ripristinare ' + righe.length + ' movimenti?', () => {
				utils.ajax('shared/prima_nota/ripristina', { IDS: righe.map(m => m.ID_MOVIMENTO) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getMovimenti();
				}, true, 0, 'PUT');
			}, this.$root);
		},

		apriEsportazione(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneMovimenti');
		},

		esportaDati(formato) {
			utils.esportaTabella({ tipo: this.esportazioneTipo, formato: formato, arrayCompleto: this.arrayMovimenti, arrayPagina: this.paginatedList.arr, idField: 'ID_MOVIMENTO', modulo: 'primaNota' });
		},

		normalizza(obj, campo) {
			obj[campo] = this.filters.formattaImporto(this.filters.parseImporto(obj[campo]));
		},
	},

	created: function () {
		this.impostaPeriodo('mese');
	},
}
</script>
